export default __webpack_public_path__ + "static/media/Jost-VariableFont_wght.3410386a.ttf";